import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import ApiClient from "../../services/api-client"
import { useTranslation } from 'react-i18next';
import { useForm, Controller } from "react-hook-form";
import BlockUi from '@availity/block-ui';
import { toast } from 'react-toastify';
import Select from 'react-select'
import Tippy from '@tippyjs/react';
import { isMobile } from "react-device-detect";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Commons from '../../util/commons'
import { useNavigate } from 'react-router-dom';

const Wizard = forwardRef((props, ref) => {

    const { t } = useTranslation();
    const [blockuiLoading, setBlockuiLoading] = useState(false);
    const [content, setContent] = useState({});
    const [fetchTaxisInfoExplanationMessVisible, setFetchTaxisInfoExplanationMessVisible] = useState(true);
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        taxpayerId: Yup.string().required(t("fieldRequired")),
        name: Yup.string().required(t("fieldRequired")),
        address: Yup.string().required(t("fieldRequired")),
        myDataInvoiceType: Yup.array().required(t("fieldRequired")).nullable(),
    });
    const { register, getValues, control, handleSubmit, setValue, formState: { errors }, trigger, clearErrors } = useForm({
        resolver: yupResolver(validationSchema)
    });

    useImperativeHandle(ref, () => ({
        getValues() {
            trigger();
            return getValues();
        },
        getErrors() {
            return { errors };
        }
    }));

    useEffect(() => {
        trigger();
        setTimeout(function () {
            clearErrors();
        });

        ApiClient.getMyDataInvoiceTypes().then(response => {
            var data = response.data;
            var options = [];
            data.forEach(element => {
                var _enumVal = "invoice" + element.key.replace(".", "_");
                var postfix = " (" + element.myDataKey + ")";
                options.push({ value: _enumVal, label: t(_enumVal) + postfix });
            });
            setContent(content => ({ ...content, myDataInvoiceTypes: options }));
        });
        ApiClient.getCompanyView().then(response => {
            var taxOffices = response.data.taxOffices.map(el => ({ value: el.id, label: el.name }));
            setContent(content => ({ ...content, taxOffices }));
        });
    }, []);

    const updateInvType = (vals) => {
        setValue("myDataInvoiceType", vals);
        trigger("myDataInvoiceType");
    };

    const update = (e) => {
        if (e.target == undefined) {
            setValue("taxOffice", { label: e.label, value: e.value });
        } else {
            setValue(e.target.name, e.target.value);
            trigger(e.target.name);
        }
    };

    const translateMyDataInvoiceTypes = types => {
        if (!types) return [];
        return types.map(el => ({ value: el.value, label: t(el.label) }));
    };

    const onClickFetchTaxPayerId = () => {
        var AFMcalledfor = getValues().taxpayerId;
        var AFMcalledby = "126235377";
        setBlockuiLoading(true);
        ApiClient.checkAfm(AFMcalledfor, AFMcalledby).then(
            response => {
                try {
                    var res = response.data.Body.rgWsPublicAfmMethodResponse;
                    var error = res.pErrorRec_out;
                    if (error && error.errorCode != null) {
                        toast.error(error.errorDescr);
                        setBlockuiLoading(false);
                        return;
                    }
                    var basic_rec = res.RgWsPublicBasicRt_out;
                    var firm_act_tab = res.arrayOfRgWsPublicFirmActRt_out;
                    setValue("name", basic_rec.onomasia);
                    var address = basic_rec.postalAddress;
                    if (basic_rec.postalAddressNo && basic_rec.postalAddressNo.trim() !== "0") {
                        address += " " + basic_rec.postalAddressNo.trim();
                    }
                    setValue("address", address);
                    if (firm_act_tab) {
                        const desc = Array.isArray(firm_act_tab.RgWsPublicFirmActRtUser)
                            ? firm_act_tab.RgWsPublicFirmActRtUser[0].firmActDescr
                            : firm_act_tab.RgWsPublicFirmActRtUser.firmActDescr;
                        setValue("subjectField", desc);
                    }
                    setValue("postalCode", basic_rec.postalZipCode);
                    setValue("city", basic_rec.postalAreaDescription);
                    setValue("number", basic_rec.postalAddressNo);
                    setValue("taxOffice", { value: basic_rec.doy, label: basic_rec.doyDescr });
                    setBlockuiLoading(false);
                } catch (err) {
                    console.error(err);
                    setBlockuiLoading(false);
                }
            },
            error => {
                if (error.response) {
                    toast.error(error.message + ": " + error.response.data.message);
                }
                setBlockuiLoading(false);
            }
        );
    };

    const hidefetchTaxisInfoExplanationMess = () => {
        setFetchTaxisInfoExplanationMessVisible(false);
    };

    function saveChanges(data) {
        localStorage.removeItem("wizard");
        var company = {
            name: data.name,
            taxpayerId: data.taxpayerId ? data.taxpayerId.trim() : "",
            taxOffice: { id: data.taxOffice.value }
        };
        if (company.taxOffice.id == undefined) {
            company.taxOffice = null;
        }
        company.branches = [{ name: data.name, subjectField: data.subjectField, address: data.address }];
        company.myDATAProvider = "MYDATA";

        ApiClient.saveCompany(company).then(
            response => {
                var savedCompany = response.data;
                var invoiceTypes = data.myDataInvoiceType.map(element => ({
                    company: { id: savedCompany.id },
                    name: element.label,
                    myDataInvoiceType: element.value,
                    series: [{ name: "A", branch: { id: savedCompany.branches[0].id }, startNumber: 0 }]
                }));
                ApiClient.saveBulkInvoiceTypeWithSeries(invoiceTypes).then(
                    () => {
                        ApiClient.UpdateUserWizard().then(response => {
                            toast.success(t("saveSucceded"));
                            localStorage.setItem("company", JSON.stringify(savedCompany));
                            localStorage.setItem("user", JSON.stringify(response.data));
                            navigate("/sale");
                            window.location.reload();
                            Commons.setDefault("invoiceTypeMessages", ["invoice2_1", "invoice11_1"]);
                        });
                    },
                    error => {
                        toast.error("Error: " + error.data);
                        console.error(error.data);
                    }
                );
                props.setShowWizard(false);
            },
            error => {
                toast.error(error.message + ": " + error.response.data.message, 20000);
                console.error(error.response.data.message);
            }
        );
    }

    const onSubmit = (data) => {
        saveChanges(data);
    };

    return (
        <BlockUi tag="div" blocking={blockuiLoading}>
            <form id="wizard_form" onSubmit={handleSubmit(onSubmit)}>

                <div className="parochos-info-box mb-3">
                    <ul style={{ paddingLeft: 16, marginBottom: 4 }}>
                        <li>{t("CompanyWizardInfo1")}</li>
                        <li>{t("CompanyWizardInfo2")}</li>
                    </ul>
                    {t("CompanyWizardInfo3")}
                </div>

                <div className="card mainInvoiceInfoCard mb-3">
                    <div className="card-header card-header-skin">
                        <i className="fa fa-building" style={{ marginRight: 8 }}></i>{t("companyAdd")}
                    </div>
                    <div className="card-body">
                        <div className="row g-3">

                            <div className="col-md-4 form-group required">
                                <label className="control-label">{t("taxpayerId")}</label>
                                <div className="input-group">
                                    <input
                                        name="taxpayerId"
                                        type="text"
                                        maxLength={32}
                                        {...register('taxpayerId', { required: true, maxLength: 32 })}
                                        onChange={update}
                                        placeholder={t("placeholderInput")}
                                        className={`form-control ${errors.taxpayerId ? 'is-invalid' : ''}`}
                                    />
                                    <Tippy
                                        interactive={true}
                                        placement={!isMobile ? "right" : "bottom"}
                                        trigger="click"
                                        visible={fetchTaxisInfoExplanationMessVisible}
                                        content={
                                            <span onClick={hidefetchTaxisInfoExplanationMess} style={{ display: 'inline-block' }} className="tooltip-skin">
                                                {t("fetchTaxisInfoExplanationMess")}
                                                <span style={{ backgroundColor: 'transparent', marginLeft: 10, cursor: 'pointer' }} onClick={hidefetchTaxisInfoExplanationMess}>
                                                    <i style={{ color: 'white' }} className='fa fa-times'></i>
                                                </span>
                                            </span>
                                        }
                                    >
                                        <span className="input-group-text fetchTaxPayerId" onClick={onClickFetchTaxPayerId}>
                                            <i className="fa fa-search"></i>
                                        </span>
                                    </Tippy>
                                    <div className="invalid-feedback">{errors.taxpayerId?.message}</div>
                                </div>
                            </div>

                            <div className="col-md-4 form-group required">
                                <label className="control-label">{t("CompanyName")}</label>
                                <input
                                    name="name"
                                    type="text"
                                    maxLength={64}
                                    {...register('name', { required: true, maxLength: 64 })}
                                    placeholder={t("placeholderInput")}
                                    onChange={update}
                                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                />
                                <div className="invalid-feedback">{errors.name?.message}</div>
                            </div>

                            <div className="col-md-4 form-group required">
                                <label className="control-label">{t("Address")}</label>
                                <input
                                    name="address"
                                    type="text"
                                    autoComplete="off"
                                    maxLength={64}
                                    {...register('address', { required: true, maxLength: 64 })}
                                    placeholder={t("placeholderInput")}
                                    onChange={update}
                                    className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                                />
                                <div className="invalid-feedback">{errors.address?.message}</div>
                            </div>

                            <div className="col-md-4 selectInputContainer form-group">
                                <label>{t("taxOffice")}</label>
                                <Controller
                                    render={({ field }) => (
                                        <Select {...field}
                                            options={content.taxOffices}
                                            className={`form-control ${errors.taxOffices ? 'is-invalid' : ''}`}
                                            onChange={update}
                                            placeholder={t("placeholderSelect")}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    )}
                                    control={control}
                                    rules={{ required: false }}
                                    name="taxOffice"
                                    defaultValue=""
                                />
                                <div className="invalid-feedback">{errors.taxOffice?.message}</div>
                            </div>

                            <div className="col-md-6 form-group">
                                <label>{t("subjectField")}</label>
                                <input
                                    name="subjectField"
                                    type="text"
                                    maxLength={150}
                                    {...register('subjectField', { maxLength: 150 })}
                                    placeholder={t("placeholderInput")}
                                    onChange={update}
                                    className={`form-control ${errors.subjectField ? 'is-invalid' : ''}`}
                                />
                                <div className="invalid-feedback">{errors.subjectField?.message}</div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="card mainInvoiceInfoCard mb-3">
                    <div className="card-header card-header-skin">
                        <i className="fa fa-list-alt" style={{ marginRight: 8 }}></i>{t("invtypesAdd")}
                    </div>
                    <div className="card-body">
                        <div className="parochos-info-box mb-3">
                            <p style={{ marginBottom: 0 }}>{t("invoiceWizardInfo")}</p>
                        </div>
                        <div className="row g-3">
                            <div className="col-md-8 selectInputContainer form-group required">
                                <label className="control-label">{t("invtypes")}</label>
                                <Controller
                                    render={({ field }) => (
                                        <Select {...field}
                                            options={translateMyDataInvoiceTypes(content.myDataInvoiceTypes)}
                                            isMulti
                                            inputId="choose-invtype-multiselect"
                                            onChange={updateInvType}
                                            placeholder={t("placeholderSelect")}
                                            className={`form-control ${errors.myDataInvoiceType ? 'is-invalid' : ''}`}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    )}
                                    control={control}
                                    rules={{ required: true }}
                                    name="myDataInvoiceType"
                                    defaultValue=""
                                />
                                <div className="invalid-feedback">{errors.myDataInvoiceType?.message}</div>
                            </div>
                        </div>
                    </div>
                </div>

            </form>
        </BlockUi>
    );
});

export default Wizard;
